module.exports = __webpack_public_path__ + "img/T1_ty_8.b3e04dfd.png";